
import { css } from 'lit';
export default css`
.dropdown-list {
  visibility: hidden;
  position: absolute;
  left: 0px;
  top: 100%;
  display: none;
  border-top-width: 1px;
  border-bottom-width: 1px;
  border-right-width: 1px;
  border-left-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgba(164, 167, 171, var(--tw-border-opacity));
  opacity: 0;
  transition-property: opacity;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
  transition-duration: 75ms;
  transition-timing-function: cubic-bezier(0.4, 0, 1, 1);
}

  .dropdown-list--language {
    right: 0;
    left: auto;
  }

  .dropdown-list {

  min-width: 277px;
}

  .dropdown-list--open {
  display: block;
}

  .dropdown-list--open {
  opacity: 1;
}

  .dropdown-list--open {
    z-index: 10000;
  }

  .dropdown-list__item {
  visibility: visible;
}

  .dropdown-list__item {
  display: flex;
}

  .dropdown-list__item {
  height: 3rem;
}

  .dropdown-list__item {
  cursor: default;
}

  .dropdown-list__item {
  align-items: center;
}

  .dropdown-list__item {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
}

  .dropdown-list__item {
  padding-left: 3rem;
}

  .dropdown-list__item {
  padding-right: 2rem;
}

  .dropdown-list__item {
  font-weight: 400;
}

  .dropdown-list__item {
  line-height: 2.5rem;
}

  .dropdown-list__item {
  --tw-text-opacity: 1;
  color: rgba(0, 0, 0, var(--tw-text-opacity));
}

  @media (min-width: 1024px) {

  .dropdown-list__item {
    font-size: 1.125rem;
  }
}

  .dropdown-list__item {
    font-size: 22px;
  }

  .dropdown-list__item--active {
  border-left-width: 3px;
}

  .dropdown-list__item--active {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

  .dropdown-list__item--active {
  --tw-bg-opacity: 1;
  background-color: rgba(242, 242, 242, var(--tw-bg-opacity));
}

  .dropdown-list__item--active {
  font-weight: 700;
}

  .dropdown-list__item--active.dropdown-list__item--hp {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}

  .dropdown-list__item--active.dropdown-list__item--hp {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}

  .dropdown-list__item--hp {
  border-top-width: 1px;
}

  .dropdown-list__item--hp {
  border-bottom-width: 1px;
}

  .dropdown-list__item--hp {
  border-right-width: 1px;
}

  .dropdown-list__item--hp {
  border-left-width: 1px;
}

  .dropdown-list__item--hp {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}

  .dropdown-list__item a:hover {
  text-decoration: underline;
}
`;